<template>
  <div class="vehicle-drilldown">
      <div class="row">
        <div class="col-12 col-md-3">
          <label for>{{ label_manufacturer }}</label><br />
          <select name :id="label_manufacturer" v-model="manufacturerId" dusk="Manufacturer">
            <option value="0" disabled>{{ label_select }}</option>
              <optgroup label="- Popular Makes -" v-if="popularManufacturers && popularManufacturers.length > 0">
                  <option
                  v-for="(popularManufacturer, index) in popularManufacturers"
                  :key="index"
                  :id="popularManufacturer.manufacturerId"
                  :value="popularManufacturer.manufacturerId"
                  :dusk="popularManufacturer.title"
                    >
                  {{ popularManufacturer.title }}
                </option>
            </optgroup>
            <optgroup :label="getAllMakesLabel">
            <option
              v-for="(manufacturer, index) in manufacturers"
              :key="index"
              :id="manufacturer.manufacturerId"
              :value="manufacturer.manufacturerId"
              :dusk="manufacturer.title"
            >{{ manufacturer.title }}</option>
            </optgroup>
          </select>
          
        </div>

        <div class="col-12 col-md-3">
          <label for>{{ label_model }} </label><br />
          <select name :id="label_model" v-model="modelId" :disabled="models.length == 0" dusk="Model">
            <option value="0" disabled>{{ label_select }}</option>
          
            <option
              v-for="(model, index) in models"
              :key="index"
              :id="model.modelId"
              :value="model.modelId"
              :dusk="model.title"
            >{{ model.title }}</option>
          
          </select>

        </div>

        <div class="col-12 col-md-3">
          <label for>{{ label_year }}</label><br />
          <select name :id="label_year" v-model="year" :disabled="years.length == 0"  dusk="Year">
            <option value="0" disabled>{{ label_select }}</option>
            <option v-for="(year, index) in years" :key="index" :value="year" :dusk="'year_' + year">{{ year }}</option>
          </select>
        </div>

        <div class="col-12 col-md-3">
          <label for> {{ label_body_type }}</label><br />
          <select name id="body_type" v-model="bodyTypeId" :disabled="bodyTypes.length == 0"  dusk="body_type">
            <option value="0" disabled>{{ label_select }}</option>
            <option
              v-for="(bodyType, index) in bodyTypes"
              :key="index"
              :value="bodyType.bodyTypeId"
              :dusk="'body_type_' + bodyType.title"
            >{{ bodyType.title }}</option>
          </select>
        </div>

        <div class="col-12">

          <div v-for="(vehicle, index) in vehicles" :key="index">
            <a href="javascript:;" v-on:click="newSelectedVehicle = vehicle.Vehicle" v-bind:style="[(vehicle.Vehicle.vehicleId == selectedVehicle) ? {'fontWeight':'700'} : {}]">{{ vehicle.Vehicle.full_name }}</a>
          </div>
        </div>

      </div>
  </div>
</template>

<script>
import sortPopularList from "../../mixins/sortPopularList";
export default {
  name: "dealer-roof",
   mixins: [sortPopularList],
  props: {
    label_manufacturer: {
      type: String,
      default: "Manufacturer"
    },
    label_model: {
      type: String,
      default: "Model"
    },
    label_year: {
      type: String,
      default: "Year"
    },
    label_body_type: {
      type: String,
      default: "Body Type"
    },
    label_loading: {
      type: String,
      default: "Loading"
    },
    label_select: {
      type: String,
      default: "Select"
    },
    vehicle_type: {
      type: Number,
      default: undefined
    },
    
  },
  data() {
    return {
      manufacturers: [],
      manufacturerId: 0,
      models: [],
      modelId: 0,
      years: [],
      year: 0,
      bodyTypes: [],
      bodyTypeId: 0,
      vehicles: [],
      newSelectedVehicle: null
    };
  },
  computed: {
    fullUrl() {
      return `/${window.culture}/${this.link}`;
    },
    selectedVehicle() {
      return this.$store.state.solutions.selectedVehicle.vehicleId;
    },
    queryString() {
      return (this.vehicle_type) ? "?type_id=" + this.vehicle_type : "";
    },
    popularManufacturers() {
      return this.isRoofJourney ? this.sortPopularList(this.manufacturers) : [];
    },
    popularModels() {
      return this.isRoofJourney ? this.sortPopularList(this.models) : [];
    },
    isRoofJourney() {
      // if there is no vehicle type, it's roof journey
      // return location.search.indexOf('type_id') > -1 ? false : true;
      return (this.vehicle_type == null) ? true : false;
    },
    getAllMakesLabel() {
      if(this.isRoofJourney && this.popularManufacturers && this.popularManufacturers.length > 0) {
        return '- All Makes -';
      }
      return '';
    },
    getAllModelsLabel() {
      if(this.isRoofJourney && this.popularModels && this.popularModels.length > 0) {
        return '- All Models -';
      }
      return '';
    },
    vehicleShareLink() {
      return window.location.href + '?' +  new URLSearchParams(this.urlParams).toString();
    }
  },
  mounted() {
    // alert(this.item);
    this.getVehicleManufacturers();
    this.getVehiclesFromCookie();
  },
  methods: {
    async getVehicleManufacturers() {
      let response = await axios.get("api/vehicle/makes" + this.queryString);
      this.manufacturers = response.data.data;
        this.loading = false;
    },
    async getVehiclesFromCookie() {
        if(this.selectedVehicle) {
          this.loading = true;
          try {
            let url = `api/vehicle/black-bar/${this.selectedVehicle}`;
            let response = await axios.get(url);
            this.vehicles = response.data.data;
            this.loading = false;
          } catch (err) {}
      }
    },
  },
  watch: {
      vehicle_type() {
            this.getVehicleManufacturers();
      },
      manufacturers() {
        this.manufacturerId = 0;
        this.vehicles = [];
      },
    async manufacturerId() {
      this.modelId = 0;
      this.loading = true;
      try {
        let url = `api/vehicle/models/${this.manufacturerId}${this.queryString}`;
        let response = await axios.get(url);
        this.models = response.data.data;
        if (this.models.length == 1) {
          this.modelId = this.models[0].modelId;
        }
        this.loading = false;
      } catch (err) {}
    },
    async modelId() {
      this.year = 0;
      this.loading = true;
      try {
        let url = `api/vehicle/model/years/${this.modelId}${this.queryString}`;
        let response = await axios.get(url);
        this.years = response.data.data;
        if (this.years.length == 1) {
          this.year = this.years[0];
        }
        this.loading = false;
      } catch (err) {}
    },
    async year() {
      this.bodyTypeId = 0;
      this.loading = true;
      try {
        let url = `api/vehicle/model/body-types/${this.modelId}/${this.year}${this.queryString}`;
        let response = await axios.get(url);
        this.bodyTypes = response.data.data;
        if (this.bodyTypes.length == 1) {
          this.bodyTypeId = this.bodyTypes[0].bodyTypeId;
        }
        this.loading = false;
      } catch (err) {}
    },
    async bodyTypeId() {
      this.loading = true;
      try {
        let url = `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}${this.queryString}`;
        let response = await axios.get(url);
        this.vehicles = response.data.data;
        this.loading = false;
      } catch (err) {}
    },
    async newSelectedVehicle() {
      if (this.newSelectedVehicle) {
        this.$store.commit("solutions/setSelectedVehicle", this.newSelectedVehicle);
        this.$emit('selectVehicle', this.newSelectedVehicle);
      }
    }
  }
};
</script>
